import {
  Box,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow
} from "@material-ui/core";
import moment from "moment";

import { useEffect, useState } from "react";
import { BiTrash } from "react-icons/bi";
import { FiEdit2 } from "react-icons/fi";
import { IoMdDownload } from "react-icons/io";
import { LuArrowDown, LuArrowDownUp, LuArrowUp } from "react-icons/lu";
import CustomAddModal from "../../../components/Common/CustomAddModal";
import CustomConfirmModal from "../../../components/Common/CustomConfirmModal";
import CustomPagination from "../../../components/Common/CustomPagination";
import { getCurrentUserId, getCurrentUserOrganizationId, toastError, toastSuccess } from "../../../utils";
import { createElectricLaytime, createElectricLaytimePdf, deleteElectricLaytime, getElectricLaytime, updateElectricLaytime } from "./action";
import LaytimeModel from "./LaytimeModel";

const formatDateOrDash = (v) => (v && moment(v).isValid() ? moment(v).format("DD-MM-YYYY") : "-");

const intialData = {
  eventTable: [
    {
      id: 1,
      fromTime: "",
      fromDay: "",
      toTime: "",
      toDay: "",
      event: "",
      timeDuration: 0,
      percentTimeToCount: 0,
      timeUsed: 0,
      cumulatedTimeUsed: 0,
      comments: ""
    }
  ],
  vesselName: "",
  cargoDesc: "",
  voyageNo: "",
  charterer: "",
  laytimePort: "",
  operation: "",
  shipmentId: "",
  cargoQty: "",
  totalTimeAllowed: "",
  dischargingRate: "",
  dischargingTerms: "",
  turnTimeClause: "",
  turnTimeAllowed: "",
  demurrageRate: "",
  despatchRate: "",
  arrivalTime: "",
  norTendered: "",
  norTerms: "",
  laytimeStarts: "",
  commencedDischarging: "",
  completedDischarging: "",
  laytimeStops: "",
  departureTime: "",
  userId: getCurrentUserId(),
  organizationId: getCurrentUserOrganizationId(),
}

const intialModelState = {
  open: false,
  type: "create",
  data: intialData,
}

const ElectricLaytime = (props) => {
  const { setLoader = () => { } } = props;
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    offset: 1,
    limit: 50,
    totalPages: 0,
    totalItems: 0,
    sortBy: "createdAt",
    sortDirection: "desc",
  });
  const [openModal, setOpenModal] = useState({ ...intialModelState });
  const [showDeleteWarning, setShowDeleteWarning] = useState({
    isOpen: false,
    id: null,
  });
  const [showUpdateWarning, setShowUpdateWarning] = useState(false);
  const [openOfflineInfo, setOpenOfflineInfo] = useState(false);

  const fetchData = async () => {
    setLoading(true);
    setLoader(true);
    try {
      const response = await getElectricLaytime({
        offset: pagination.offset || 1,
        limit: pagination.limit || 50,
        sortBy: pagination.sortBy,
        sortDirection: pagination.sortDirection,
      });
      if (!response) {
        throw new Error("Failed to fetch data");
      }
      setData(response.data || []);
      setPagination((prev) => ({
        ...prev,
        totalPages: response.totalPages,
        totalItems: response.totalItems,
      }));

    } catch (err) {
      toastError(err.message);
    } finally {
      setLoading(false);
      setLoader(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination.offset, pagination.limit, pagination.sortBy, pagination.sortDirection]);

  const onChangePagination = (type, key) => {
    setPagination((prev) => {
      const currentPage = prev.offset || 1;
      const limit = prev.limit || 10;

      let newOffset = currentPage;

      if (type === "first") {
        newOffset = 1;
      } else if (type === "dec" && currentPage > 1) {
        newOffset = currentPage - 1;
      } else if (type === "inc" && currentPage * limit < pagination.totalItems) {
        newOffset = currentPage + 1;
      }

      return {
        ...prev,
        offset: newOffset,
      };
    });
  };

  const headers = [
    "S.No",
    "Operation",
    "Port",
    "Cargo",
    "Qty",
    "Rate",
    "Turn Time",
    "B/L Date",
    "Demurrage",
    "Despatch",
    "Allowed Time",
    "Used Time",
    "Difference",
    "Dem/Desp",
    "Action"
  ];

  const handleSortClick = (sortKey) => {
    let newSortDirection = "asc";
    if (pagination.sortBy === sortKey) {
      if (pagination.sortDirection === "asc") newSortDirection = "desc";
      else if (pagination.sortDirection === "desc") {
        newSortDirection = sortKey === "createdAt" ? "asc" : "";
      }
    } else {
      newSortDirection = sortKey === "createdAt" ? "desc" : "asc";
    }

    let nextSortBy = sortKey;
    if (!newSortDirection) {
      nextSortBy = "createdAt";
      newSortDirection = "desc";
    }

    setPagination((prev) => ({
      ...prev,
      offset: 1,
      sortBy: nextSortBy,
      sortDirection: newSortDirection,
    }));
  };

  const handleOpenModel = (data) => {
    if (data) {
      setOpenModal((prev) => {
        return {
          open: true,
          type: "edit",
          data: data,
        };
      });
    } else {
      setOpenModal((prev) => {
        return {
          open: true,
          type: "create",
          data: intialData,
        };
      });
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    try {
      let response
      if (openModal.type === "create") {
        response = await createElectricLaytime(openModal.data);
      } else {
        const { _id, ...data } = openModal.data;
        response = await updateElectricLaytime({ _id }, data);
      }
      if (!response) {
        toastError(`Failed to ${openModal.type === "create" ? "create" : "update"} data`);
      }
      toastSuccess(`Data ${openModal.type === "create" ? "created" : "updated"} successfully`);
      setOpenModal(intialModelState);
      fetchData();
    } catch (err) {
      toastError(err.message);
    } finally {
      setShowUpdateWarning(false);
      setLoading(false);
    }
  };

  const handleDownloadPdf = async () => {
    setLoading(true);
    try {
      let response
      response = await createElectricLaytimePdf(openModal.data);
      if (!response) {
        toastError(`Failed to create data`);
      }
      return response.data || response;
    } catch (err) {
      toastError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const showDeleteWarningModel = (id) => {
    setShowDeleteWarning({
      isOpen: true,
      id,
    });
  }

  const handleDelete = async (id) => {
    setLoading(true);
    try {
      let response
      response = await deleteElectricLaytime({ _id: id });
      if (!response) {
        toastError(`Failed to delete data`);
      }
      toastSuccess(`Data deleted successfully`);
      fetchData();
    } catch (err) {
      toastError(err.message);
    } finally {
      setShowDeleteWarning({
        isOpen: false,
        id: null,
      });
      setLoading(false);
    }
  };


  function DownloadIndexHtml() {
    const handleDownload = () => {
      const link = document.createElement('a');
      link.href = '/htmlForms/laytime.html';
      link.download = `${Date.now()}_laytime.html`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    };

    return (
      <>
        <button
          onClick={() => setOpenOfflineInfo(true)}
          className="h-7 px-3 bg-[#313C4C] hover:bg-[#1e2632] text-white text-[11px] font-medium rounded-none flex items-center gap-1.5 transition-colors cursor-pointer shadow-sm"
        >
          <IoMdDownload size={13} />
          <span>Offline Form</span>
        </button>
        <CustomAddModal
          open={openOfflineInfo}
          handleClose={() => setOpenOfflineInfo(false)}
          onClose={() => setOpenOfflineInfo(false)}
          title="Offline Laytime Form"
          saveLabel="Download"
          onSubmitConfirm={() => { handleDownload(); setOpenOfflineInfo(false); }}
        >
          <div className="text-[12px] text-slate-700">
            <div className="border border-slate-200 bg-slate-50 px-3 py-3">
              <div className="font-semibold text-slate-900 mb-1">What is this file?</div>
              <p>A blank Laytime form saved as an HTML file. It opens in any web browser, so you can fill it in on a computer without logging in to this app, then bring the filled form back into this page.</p>
            </div>
            <div className="font-semibold text-slate-900 mt-4 mb-2">How to use it</div>
            <ol className="list-decimal pl-5 space-y-2">
              <li>Click <strong>Download</strong> below to save the offline form (.html file).</li>
              <li>Open the downloaded file in your browser and fill in the details.</li>
              <li>In the form, click <strong>Download HTML</strong> to save your filled-in copy.</li>
            </ol>
            <div className="font-semibold text-slate-900 mt-4 mb-2">Where can I import the filled form?</div>
            <ol className="list-decimal pl-5 space-y-2">
              <li>On this page, click <strong>Create Laytime</strong> (top right).</li>
              <li>In the window that opens, click <strong>Upload HTML</strong> at the top.</li>
              <li>Click <strong>Choose completed HTML file</strong> and select the file you saved in the previous step. The form fields are filled in from it.</li>
            </ol>
            <p className="mt-3 text-slate-600">The same <strong>Upload HTML</strong> option is also available in the Laytime panel of an operation (Operations page, open an operation, then <strong>View</strong> in the Laytimes column).</p>
          </div>
        </CustomAddModal>
      </>
    );
  }

  return (
    <div className="min-h-[calc(100vh-110px)] w-full">
      <div className="mb-2 flex gap-2 justify-end items-center">
        {DownloadIndexHtml()}
        <button
          className="h-7 px-3 bg-[#313C4C] hover:bg-[#1e2632] text-white text-[11px] font-medium rounded-none flex items-center gap-1.5 transition-colors cursor-pointer shadow-sm"
          onClick={() => handleOpenModel()}
        >
          Create Laytime
        </button>
      </div>
      <TableContainer component={Paper} className="!rounded-none !shadow-sm">
        {pagination?.totalItems > pagination?.limit && (
          <CustomPagination
            onChangePagination={onChangePagination}
            filters={pagination}
            totalPage={pagination?.totalItems}
          />
        )}
        {/* Always render table */}
        <Table className="universal-table">
          <TableHead className="bg-[#313C4C]">
            <TableRow>
              {headers.map((header) => {
                const sortMap = {
                  "Operation": "operation",
                  "Port": "laytimePort",
                  "Cargo": "cargoDesc",
                  "Qty": "cargoQty",
                  "Rate": "dischargingRate",
                  "Turn Time": "turnTimeAllowed",
                  "B/L Date": "billOfLadingDate",
                  "Demurrage": "demurrageRate",
                  "Despatch": "despatchRate",
                  "Allowed Time": "totalTimeAllowed",
                  "Used Time": "cumulatedTimeUsed",
                  "Difference": "norTendered",
                  "Dem/Desp": "norTerms",
                };
                const sortKey = sortMap[header];
                return (
                  <TableCell
                    key={header}
                    className={`text-white py-1.5 text-[11px] font-medium border-r border-gray-400 whitespace-nowrap ${headers.indexOf(header) === headers.length - 1
                      ? "border-r-0"
                      : ""
                      } ${sortKey ? 'cursor-pointer' : ''}`}
                    onClick={() => sortKey ? handleSortClick(sortKey) : undefined}
                  >
                    <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
                      {header}
                      {sortKey && (
                        <div style={{ color: pagination.sortBy === sortKey ? "#fff" : "rgba(255,255,255,0.4)", display: "flex", alignItems: "center" }}>
                          {pagination.sortBy === sortKey && pagination.sortDirection === "desc" ? <LuArrowDown size={13} /> : pagination.sortBy === sortKey && pagination.sortDirection === "asc" ? <LuArrowUp size={13} /> : <LuArrowDownUp size={13} />}
                        </div>
                      )}
                    </div>
                  </TableCell>
                )
              })}
            </TableRow>
          </TableHead>
          <TableBody>
            {loading ? (
              <TableRow>
                <TableCell colSpan={headers.length} align="center" className="!bg-white">
                  <Box display="flex" justifyContent="center" alignItems="center" height="440px">
                  </Box>
                </TableCell>
              </TableRow>
            ) : data.length > 0 ? (
              data.map((row, index) => (
                <TableRow
                  key={index}
                  className="h-7 cursor-pointer hover:bg-gray-50"
                  onDoubleClick={() => handleOpenModel(row)}
                >
                  <TableCell className="p-0 px-2 text-[11px] font-medium border-gray-400">{(pagination.offset - 1) * pagination.limit + index + 1}</TableCell>
                  <TableCell className="p-0 px-2 text-[11px] font-medium border-gray-400">{row.operation}</TableCell>
                  <TableCell className="p-0 px-2 text-[11px] font-medium border-gray-400">{row.laytimePort}</TableCell>
                  <TableCell className="p-0 px-2 text-[11px] font-medium border-gray-400">{row.cargoDesc}</TableCell>
                  <TableCell className="p-0 px-2 text-[11px] font-medium border-gray-400">{row.cargoQty}</TableCell>
                  <TableCell className="p-0 px-2 text-[11px] font-medium border-gray-400">{row.dischargingRate}</TableCell>
                  <TableCell className="p-0 px-2 text-[11px] font-medium border-gray-400">{row.turnTimeAllowed}</TableCell>
                  <TableCell className="p-0 px-2 text-[11px] font-medium border-gray-400">{formatDateOrDash(row.billOfLadingDate)}</TableCell>
                  <TableCell className="p-0 px-2 text-[11px] font-medium border-gray-400">{row.demurrageRate}</TableCell>
                  <TableCell className="p-0 px-2 text-[11px] font-medium border-gray-400">{row.despatchRate}</TableCell>
                  <TableCell className="p-0 px-2 text-[11px] font-medium border-gray-400">{row.totalTimeAllowed}</TableCell>
                  <TableCell className="p-0 px-2 text-[11px] font-medium border-gray-400">{formatDateOrDash(row.cumulatedTimeUsed)}</TableCell>
                  <TableCell className="p-0 px-2 text-[11px] font-medium border-gray-400">{formatDateOrDash(row.norTendered)}</TableCell>
                  <TableCell className="p-0 px-2 text-[11px] font-medium border-gray-400">{row.norTerms}</TableCell>
                  <TableCell className="p-0 px-2">
                    <div className="flex items-center gap-1">
                      <button
                        onClick={() => handleOpenModel(row)}
                        className="p-1 text-[#313C4C] hover:text-[#1e2632] transition cursor-pointer"
                        title="Edit"
                      >
                        <FiEdit2 size={15} style={{ display: "block" }} />
                      </button>
                      <button
                        onClick={() => showDeleteWarningModel(row._id)}
                        className="p-1 text-rose-600 hover:text-rose-800 transition cursor-pointer"
                        title="Delete"
                      >
                        <BiTrash className="table-action-delete-icon" style={{ width: "15px", height: "15px", minWidth: "15px", minHeight: "15px" }} />
                      </button>
                    </div>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={headers.length} className="text-center">
                  No data available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
        {pagination?.totalItems > pagination?.limit && (
          <CustomPagination
            onChangePagination={onChangePagination}
            filters={pagination}
            totalPage={pagination?.totalItems}
          />
        )}
      </TableContainer>

      <CustomAddModal
        title={
          openModal.type === "create"
            ? "Create Laytime"
            : "Edit Laytime"
        }
        open={openModal.open}
        maxWidth="lg"
        saveLabel={openModal.type === "create" ? "Create" : "Update"}
        handleClose={() => setOpenModal((prev) => ({ ...prev, open: false }))}
        onSubmitConfirm={() => {
          if (openModal.type === "create") {
            handleSubmit();
          } else {
            setShowUpdateWarning(true);
          }
        }}
      >
        <LaytimeModel state={openModal} setState={setOpenModal} onDownloadElectricPdf={handleDownloadPdf} />
      </CustomAddModal>

      <CustomConfirmModal
        open={showDeleteWarning.isOpen}
        handleClose={() => setShowDeleteWarning((prev) => ({ ...prev, isOpen: false }))}
        title="Delete Laytime"
        message="Are you sure you want to delete this laytime?"
        type="warning"
        confirmText="DELETE"
        cancelText="Cancel"
        note="This action cannot be undone."
        onSubmitConfirm={() => handleDelete(showDeleteWarning.id)}
      />
      <CustomConfirmModal
        open={showUpdateWarning}
        handleClose={() => setShowUpdateWarning(false)}
        title="Update Laytime"
        message="Are you sure you want to update this laytime?"
        type="warning"
        confirmText="UPDATE"
        cancelText="Cancel"
        note="Please double check all details before updating this laytime. This action cannot be undone."
        onSubmitConfirm={() => handleSubmit()}
      />


    </div>
  );
};

export default ElectricLaytime;
